module.exports = __webpack_public_path__ + "img/report2-1.579c0b33.jpg";